import React, { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import ErrorHistoryDialog from "./errorHistoryDialog";
import { getFormattedDateTime } from "utils/helper";

const ErrorDetailsPreview = ({ row, details, history = [] }) => {
  const [open, setOpen] = useState(false);

  const lastHistoryEntry = history[history.length - 1] || null;

  if (row.error_exists === "No") {
    return (
      <Box py={1}>
        <Typography fontSize={13} color="success.main" fontWeight={600}>
          {lastHistoryEntry?.type === "No" && lastHistoryEntry?.created_by
            ? `No error found by ${lastHistoryEntry.created_by} on ${getFormattedDateTime(lastHistoryEntry.created_at)}`
            : "No errors"}
        </Typography>

        {details?.no_error_reason ? (
          <Typography fontSize={12} color="text.secondary" mt={0.5}>
            {details.no_error_reason}
          </Typography>
        ) : null}

        <Button
          size="small"
          variant="text"
          onClick={() => setOpen(true)}
          sx={{ mt: 0.5, px: 0 }}
        >
          Details
        </Button>

        <ErrorHistoryDialog
          open={open}
          onClose={() => setOpen(false)}
          history={history}
        />
      </Box>
    );
  }

  if (row.error_exists === "Yes") {
    return (
      <Box py={1}>
        <Typography fontSize={13} color="error.main" fontWeight={600}>
          {lastHistoryEntry?.type === "Yes" && lastHistoryEntry?.created_by
            ? `Error(s) found by ${lastHistoryEntry.created_by} on ${getFormattedDateTime(lastHistoryEntry.created_at)}`
            : "Error reported"}
        </Typography>

        <Typography fontSize={11} color="text.secondary" mt={0.5}>
          {history.length} entr{history.length === 1 ? "y" : "ies"}
        </Typography>

        <Button
          size="small"
          variant="text"
          onClick={() => setOpen(true)}
          sx={{ mt: 0.5, px: 0 }}
        >
          Details
        </Button>

        <ErrorHistoryDialog
          open={open}
          onClose={() => setOpen(false)}
          history={history}
        />
      </Box>
    );
  }

  return <Typography fontSize={12}>-</Typography>;
};

export default ErrorDetailsPreview;
